module.exports = __webpack_public_path__ + "static/assets/ea841f642eccaac716566ee0dbcda112.svg";